"use client";

import * as X from "@/ui";
import Intercom from "@intercom/messenger-js-sdk";


export function useIntercom(showIntercom: boolean, user?: {
  user_id?: string;
  email?: string;
  name?: string;
  created_at?: number;
}) {
  X.useEffect([showIntercom], () => {
    if (typeof window === "undefined") {
      return;
    }

    if (showIntercom === false) {
      document.body.classList.add("X-Intercom-Hidden");

    } else {
      document.body.classList.remove("X-Intercom-Hidden");
    }
  });

  X.useEffect([user], () => {
    if (typeof window === "undefined") {
      return;
    }

    if (!process.env.NEXT_PUBLIC_INTERCOM_APP_ID) {
      return;
    }

    Intercom({
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
      custom_launcher_selector: ".X-Open-Intercom",
      ...user,
    });

    return () => {
      if (window.Intercom) {
        window.Intercom("shutdown");
      }
    };
  });
}
